import { Injectable } from '@angular/core';

@Injectable()
export class registrationInfo {
    public accountId: number;
    public firstName: string;
    public lastName: string;
    public userMail: string;
    public password: string;
    public companyName: string;
    public address: string;
    public state: string;
    public postalCode: string;
    public countryId: string;
    public diallingCode: string;
    public mobileNumber: string;
    public countryName: string;
    public vatCode: string;
    public solidoNumber: string;
    public accessIdentifier: string;
    public parentId: number;
    public languageCode: string;
    public message?: string;
    public professional: boolean;
    public trueInformation: boolean;
    public termsConditions: boolean;
    public regDate: string;
    public personalDataAccess: boolean;
    public agrement?: string;
    public siren?: string;
    public ndAccess?: boolean;
    public asmdorAccess?: boolean;
    public rateLimit?: number;
    public siret?: string;
    public registerNumber?: string;
    public eInvoice?: string;
    public routingCode?: string;
    public suffix?: string;
}